import { Tooltip, TooltipContent, TooltipTrigger } from '@tempo-io/sui-tooltip';
import { useTranslation } from 'react-i18next';
import { removeSystemFieldNamePrefix } from '../../utils/Utilities';
import { RequiredMarker } from '../RequiredMarker';

export const CustomFieldLabel = ({
  fieldName,
  isSystem = false,
  fontStyle = 'italic',
  required = false,
  originalFieldName,
  ...props
}: {
  fieldName: string;
  isSystem: boolean;
  fontStyle?: string;
  required?: boolean;
  originalFieldName?: string;
}) => {
  const { t } = useTranslation('translation');

  const displayedName = isSystem ? removeSystemFieldNamePrefix(fieldName) : fieldName;

  const original = originalFieldName
    ? isSystem
      ? removeSystemFieldNamePrefix(originalFieldName)
      : originalFieldName
    : undefined;
  const renamed = original !== undefined && original !== displayedName;

  if (isSystem) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="fs-exclude"
            data-dd-action-name="FIM 3 System Custom Field - tooltip label redacted"
            style={{ fontStyle: fontStyle || 'italic' }}
            {...props}
          >
            {displayedName}
            {required && <RequiredMarker />}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          {renamed
            ? t(($) => $.intake.general.systemFieldWithNameToolTip, { name: original })
            : t(($) => $.intake.general.systemFieldToolTip)}
        </TooltipContent>
      </Tooltip>
    );
  }

  const label = (
    <span
      className="fs-exclude"
      data-dd-action-name="FIM 3 Custom Field - label redacted"
      data-testid={`fim3-custom-field-label-${fieldName}`}
      {...props}
    >
      {fieldName}
      {required && <RequiredMarker />}
    </span>
  );

  return renamed ? (
    <Tooltip>
      <TooltipTrigger asChild>{label}</TooltipTrigger>
      <TooltipContent>{original}</TooltipContent>
    </Tooltip>
  ) : (
    label
  );
};
